export default "<p>ajouter-sous-meilleurs-biens works!</p>\r\n";